export const BookingFee = ({ ticket, currency }) => (
  <div>
    + {currency}
    {ticket.get('booking_fee_fixed', 0).toFixed(2)} fee
  </div>
);
